import CheckCircle from "@mui/icons-material/CheckCircle";
import CircleOutlined from "@mui/icons-material/CircleOutlined";
import CircularProgress from "@mui/material/CircularProgress";
import { fontSizes } from "healthex-common//sizes";
import { colors } from "healthex-common/colors";
import { fontWeights } from "healthex-common/weights";
import React from "react";
import styled from "styled-components";
import { FlexColumn, FlexRow } from "./common.styles";
import { HXMobileButton } from "./HXButton";
import { ContentContainer as HXContentContainer, Subtitle as HXSubtitle, MailtoLink, Text, TinyText } from "./HXMobilePage.styles";
import { multilineEllipsis } from "./base.styles";
export const ContentContainer = styled(HXContentContainer) `
    gap: 24px;
    padding-bottom: 24px;
`;
export const MediumSubtitle = styled(HXSubtitle) `
    font-size: ${fontSizes.MEDIUM};
`;
export const ConsentButton = styled(HXMobileButton) `
    color: ${colors.tulip_main};
`;
export const CheckCircleIcon = styled(CheckCircle) `
    width: 24px;
    height: 24px;
`;
export const CircleOutlinedIcon = styled(CircleOutlined) `
    width: 24px;
    height: 24px;
`;
export const ProofOfConsentDownloadContainer = styled(FlexColumn) `
    gap: 8px;
`;
const ProofOfConsentCircularProgress = styled(CircularProgress) `
    color: ${colors.black_30};
    width: 16px !important;
    height: 16px !important;
    margin-right: 4px;
`;
export const DownloadProofOfConsentButton = styled(HXMobileButton).attrs({
    variant: "outlined",
}) ``;
export const DownloadProofOfConsentLoadingButton = styled(HXMobileButton).attrs({
    variant: "outlined",
    startIcon: React.createElement(ProofOfConsentCircularProgress),
}) ``;
export const ProofOfConsentStatusText = styled(TinyText) `
    color: ${(props) => (props.isError ? colors.tulip_main : colors.black_lighter)};
`;
export const ProofOfConsentStatusEmail = styled(MailtoLink) `
    color: ${colors.tulip_main};
    font-size: ${fontSizes.TINY};
    font-weight: ${fontWeights.NORMAL};
    letter-spacing: 0.4px;
`;
export const PatientStudyEmailText = styled(Text) `
    ${multilineEllipsis(2)}
`;
export const PatientDetailsOrgLogoContainer = styled(FlexRow) `
    width: 88px;
    height: 88px;
    align-self: center;
    overflow: hidden;
    border-radius: 1000px;
    border: 1px solid ${colors.blue_30};
    background: ${colors.white_main};
`;
export const PatientDetailsOrgLogoImg = styled.img.attrs({ width: "100%", height: "100%" }) `
    object-fit: contain;
`;
